export const IS_LOGGED_IN = '/api/auth/is-logged-in'

export const AUTH_LOGIN = '/api/auth/login'

export const QLIK_AUTH = '/api/auth/qlik-auth'

export const AUTH_LOGOUT = '/api/auth/logout'

export const AUTH_QLIK = '/api/auth/auth-qlik'

export const JWT_LOGIN = '/api/auth/sso/jwt'

export const PL_LOGIN = '/api/auth/sso/pl/login'
export const PL_SAML_AUTHENTICATE = '/api/auth/sso/pl/authenticate'

export const TCP_LOGIN = '/api/auth/sso/tcp/login'
export const TCP_SAML_AUTHENTICATE = '/api/auth/sso/tcp/authenticate'

export const SESSION_ROUTES_TO_IGNORE = [
  AUTH_LOGIN,
  JWT_LOGIN,
  PL_LOGIN,
  PL_SAML_AUTHENTICATE,
  TCP_LOGIN,
  TCP_SAML_AUTHENTICATE,
  AUTH_QLIK
]
